var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.8917 8.62632C23.6034 7.74365 22.8163 7.17331 21.8866 7.17331H15.8913L14.0033 1.44753C13.7131 0.567337 12.9277 0 12.0007 0C11.9977 0 11.9947 -2.57136e-08 11.9917 4.67804e-05C11.0609 0.00369766 10.2758 0.578055 9.99164 1.4633L8.1587 7.17331H2.11344C1.18142 7.17331 0.393742 7.74557 0.106812 8.63114C-0.180164 9.51671 0.122513 10.4413 0.877941 10.9866L5.7692 14.5174L3.88648 20.2273C3.5951 21.111 3.89272 22.0369 4.64468 22.5861C5.02234 22.862 5.45583 23 5.8896 23C6.31943 23 6.7495 22.8644 7.12529 22.5931L12.025 19.0563L16.8666 22.5872C17.6177 23.135 18.5904 23.1376 19.3446 22.594C20.0989 22.0505 20.4027 21.1277 20.1188 20.2431L18.2807 14.5174L23.1304 10.9806C23.8812 10.433 24.1801 9.50894 23.8917 8.62632Z",
    fill: props.fill
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNews);
export default __webpack_public_path__ + "static/media/icon_news.d7517ed5c872f3b3063d4cbc0a089df3.svg";
export { ForwardRef as ReactComponent };